export enum Condition {
    AND = 'AND',
    OR = 'OR'
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/ubi-core/expression/condition.ts